import Input from './input';
import Cursor from './cursor';
import Gallery from './gallery';
import Map from './map';
import Progress from './progress';
import Submodule from './submodule';
import Timer from './timer';
import Video from './video';

export default {
	...Input,
	...Cursor,
	...Gallery,
	...Map,
	...Progress,
	...Submodule,
	...Timer,
	...Video
};
